import { Action } from '@ngrx/store';

export const SessionActions = {
  NEW_SESSION: '[Scanner] New Session',
  SESSIONS_FETCH: '[Sessions] Sessions Fetch',
  SESSIONS_RECEIVED: '[Sessions] Sessions Received',
  SESSIONS_FETCH_ERROR: '[Sessions] Sessions Fetch Error',
};

export interface IPayloadAction extends Action {
  payload?: any;
}

export class NewSession implements IPayloadAction {
  readonly type = SessionActions.NEW_SESSION;
}

export class SessionsFetch implements IPayloadAction {
  readonly type = SessionActions.SESSIONS_FETCH;
}

export class SessionsFetchError implements IPayloadAction {
  readonly type = SessionActions.SESSIONS_FETCH_ERROR;
  constructor(public payload) {}
}

export class SessionsReceived implements IPayloadAction {
  readonly type = SessionActions.SESSIONS_RECEIVED;
  constructor(public payload) {}
}

